var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarketplaceNavDeadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.901 5.892l-1.05-4.372c-.22-.9-1-1.52-1.91-1.52H3.045c-.9 0-1.69.63-1.901 1.52L.095 5.892c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29v6.943c0 1.1.9 2 2 2H17c1.1 0 2-.9 2-2V9.063c.09-.09.2-.18.28-.28.641-.82.871-1.87.621-2.891zm-2.99-3.901l1.05 4.371c.1.42.01.84-.25 1.17-.14.18-.44.47-.941.47-.61 0-1.14-.49-1.21-1.14l-.58-4.861 1.93-.01zM10.997 2h1.96l.541 4.521c.05.39-.07.78-.33 1.07-.22.26-.54.41-.95.41-.67 0-1.22-.59-1.22-1.31V2.001zM6.487 6.522l.55-4.521h1.96v4.691c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41-.25-.29-.37-.68-.33-1.07zm-4.452-.16l1.01-4.361h1.971l-.58 4.861c-.08.65-.6 1.14-1.21 1.14-.49 0-.8-.29-.93-.47-.27-.32-.36-.75-.26-1.17z",
    fill: "#AFC5FF"
  })));
}

export default SvgMarketplaceNavDeadIcon;